module.exports = __webpack_public_path__ + "img/icon_peitaoziliao.a3ca8645.svg";